/* eslint-disable */
import React from 'react'
import {Link} from 'react-router-dom'
import http from '../Interceptor/Interseptor'
import {Icon, message} from 'antd'
import Select from 'react-select'
import SinglePicker from '../BaseComponent/singlePicker'
import {MDBCol} from 'mdbreact'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import {DatePicker, MuiPickersUtilsProvider} from 'material-ui-pickers'
import jMoment from 'moment-jalaali'
import moment from 'moment'
import JalaliUtils from 'material-ui-pickers-jalali-utils'
jMoment.loadPersian({dialect: 'persian-modern', usePersianDigits: true})

class CreateDriverCartStation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      cartStationId: '',
      driverId: '',
      drivers: [],
      cartStations: [],
      deliveryDate: null
    }
  }

  submit(e) {
    e.preventDefault()
  }

  changeActivityDate = (deliveryDate) => {
    this.setState({deliveryDate})
  }

  componentDidMount() {
    this.getDrivers()
    this.getCartStations()
  }

  epochFrom = (x) => {
    var jalaiDate = this.convertDigit(jMoment(x).format('jYYYY/jMM/jDD'))
    var concatDayMount = jalaiDate.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = moment(x, 'jYYYY/jM/jD').format('YYYY/MM/D')
    let from = miladiDate + ' ' + '00:00'
    let fromEpoch = moment.utc(from).valueOf()

    if (n >= 0) {
      return fromEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return fromEpoch - 3.5 * 3600 * 1000
    } else {
      return fromEpoch - 3.5 * 3600 * 1000
    }
    // return fromEpoch - (3.5 * 3600 * 1000);
  }

  getDrivers = () => {
    return http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_DRIVER}`, {})
      .then((response) => {
        if (response.data.error == null) {
          var drivers = response.data.object
          for (let i = 0; i < drivers.length; i++) {
            drivers[i]['value'] = drivers[i].personId
            drivers[i]['label'] = drivers[i].personId + ' - ' + drivers[i].name
          }
          this.setState({
            drivers: response.data.object
          })
          return response
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  getCartStations = () => {
    return http
      .get(`cartStation/list`, {})
      .then((response) => {
        if (response.data.error == null) {
          var carts = response.data.object
          for (let i = 0; i < carts.length; i++) {
            carts[i]['value'] = carts[i].id
            carts[i]['label'] = carts[i].id + ' - ' + carts[i].title
          }
          this.setState({
            cartStations: response.data.object
          })
          return response
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  createCartStation() {
    let driverId = this.state.driverId === null || this.state.driverId === '' ? '' : this.state.driverId.personId
    let cartStation =
      this.state.cartStationId === null || this.state.cartStationId === '' ? '' : this.state.cartStationId.id
    let {deliveryDate} = this.state
    if (driverId === '' || cartStation === '' || deliveryDate === null) {
      message.error('فیلدهای ستاره دار وارد شود')
    } else if (deliveryDate === undefined) {
      message.error('تاریخ وارد شده معتبر نیست')
    } else {
      let data = {
        deliveryDate: this.epochFrom(this.state.deliveryDate),
        driverId,
        cartStationId: cartStation
      }
      http.post(`cartStationDriver/create`, data, {}).then((res) => {
        if (res.data.error === null) {
          message.success('جایگاه رساننده با موفقیت اضافه شد')
          setTimeout(() => {
            window.location.assign('/driverCartStation/report')
          }, 3000)
        }
      })
    }
  }

  selectedDriver = (driverId) => {
    this.setState({
      driverId
    })
  }

  selectCartStation = (cartStationId) => {
    this.setState({
      cartStationId
    })
  }

  date(props) {
    return <input className="form-control" {...props} />
  }

  handleDateChange = (deliveryDate) => {
    this.setState({
      deliveryDate
    })
  }

  nextDay = () => {
    this.setState({
      deliveryDate: moment().add(1, 'days')
    })
  }

  render() {
    return (
      <div className="rtl printA4Page">
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>توزیع</li>
            <li>جایگاه</li>
            <li>افزودن جایگاه رساننده </li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>افزودن جایگاه رساننده </p>
            </div>
            <div className="formComponent">
              <label className="font-weight-bold">
                تاریخ :<span className="requireFiled font-weight-bold">*</span>
              </label>
              <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                <DatePicker
                  inline
                  okLabel="تأیید"
                  autoOk={true}
                  leftArrowIcon={<Icon type="left" />}
                  rightArrowIcon={<Icon type="right" />}
                  cancelLabel="لغو"
                  labelFunc={(deliveryDate) => (deliveryDate == null ? '' : deliveryDate.format('jYYYY/jM/jDD'))}
                  value={this.state.deliveryDate}
                  id="date"
                  onChange={this.handleDateChange}
                  TextFieldComponent={this.date}
                  readOnly
                />
              </MuiPickersUtilsProvider>
            </div>
            {this.state.deliveryDate === null && (
              <div>
                <button className="btn btn-dark btn-sm" onClick={this.nextDay}>
                  <span className="font-weight-bold">تاریخ فردا</span>
                </button>
              </div>
            )}
            <div className="formComponent">
              <label className="mb-2 mr-sm-2 font-weight-bold">
                رساننده
                <span className="requireFiled font-weight-bold">*</span>
              </label>
              <Select
                value={this.state.driver}
                onChange={this.selectedDriver}
                options={this.state.drivers}
                isClearable={true}
                placeholder=""
              />
            </div>
            <div className="formComponent">
              <label className="mb-2 mr-sm-2 font-weight-bold">
                جایگاه
                <span className="requireFiled font-weight-bold">*</span>
              </label>
              <Select
                value={this.state.cartStationId}
                onChange={this.selectCartStation}
                options={this.state.cartStations}
                isClearable={true}
                placeholder=""
              />
            </div>

            <div className="formComponent selectComponent">
              <button className="btn btn-info btn-block jasperBtn" onClick={this.createCartStation.bind(this)}>
                افزودن جایگاه رساننده
              </button>
              <p className="errorText" id="errorText" />
            </div>
          </form>
        </div>
      </div>
    )
  }
}
export default CreateDriverCartStation
